import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useParams, Outlet } from 'react-router';
import { message, Button } from '@linktivity/link-ui';
import { LeaveConfirmer, Loader } from '@link/share/components';
import { allotmentApi } from '@link/supplier/services';
import { AllotmentSetting } from '@link/supplier/services/types';
import { useStore } from '@link/supplier/stores';
import Header from '../Header';
import Sidebar from './Sidebar';
import styles from './allotment.module.css';

const AllotmentLayout = () => {
  const { t } = useTranslation();
  const { poolId } = useParams();
  const { allotment } = useStore();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (poolId) {
      allotment.getAlloment(poolId);
    }
    return () => {
      allotment.clearAlloment();
    };
  }, [allotment, poolId]);
  const updateAllotmentSetting = useCallback(
    (newSetting?: AllotmentSetting) => {
      setLoading(true);
      const {
        poolId,
        name,
        supplierId,
        supplierInventoryId,
        bundles,
        segments,
        otaSettings,
        calendarEdits,
        segmentRules,
        dateSettings,
        freesale
      } = newSetting || allotment;

      return allotmentApi
        .updateAllotmentSetting({
          body: {
            poolId,
            name,
            supplierId,
            supplierInventoryId,
            bundles,
            segments,
            otaSettings,
            calendarEdits,
            segmentRules,
            dateSettings,
            freesale
          }
        })
        .then(res => {
          if (res.poolId) {
            message.success(
              t('common.successUpdatedMsg', {
                name: t('layouts.sidebar.allotmentSetting')
              })
            );
            allotment.setAlloment(res);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [allotment, t]
  );

  return (
    <div className={styles.allotment}>
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.inner}>
            {allotment.loaded ? (
              <div className={styles.content}>
                <div className={styles.header}>
                  <div className={styles.headerInfo}>
                    <p className={styles.headerName}>
                      {allotment.originalName}
                    </p>
                  </div>
                  <div className={styles.headerActions}>
                    <Button
                      loading={loading}
                      disabled={!allotment.isBlocked}
                      onClick={() => updateAllotmentSetting()}
                    >
                      {t('share.common.save')}
                    </Button>
                  </div>
                </div>
                <Outlet context={{ updateAllotmentSetting }} />
              </div>
            ) : (
              <Loader />
            )}
          </div>
        </main>
      </div>
      <LeaveConfirmer
        isBlocked={allotment.isBlocked}
        name={t('views.allotmentSettings.title')}
        reset={() => allotment.resetAllotment()}
      />
    </div>
  );
};
const ObserverAllotmentLayout = observer(AllotmentLayout);
export default ObserverAllotmentLayout;
